import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// Force rebuild 2024-11-18
createRoot(document.getElementById("root")).render(_jsx(App, {}));
